import Vue from "vue";
import store from '@/store.js'
import router from '@/router.js'
import App from '@/App.vue'
// import 'bootstrap/dist/css/bootstrap.css'
// import 'bootstrap-vue/dist/bootstrap-vue.css'
import VueHead from 'vue-head'

Vue.config.productionTip = false;
Vue.use(VueHead)
/* eslint-disable no-new */
new Vue({
  el: '#app',
  store,
  router,
  render: h => h(App),
})